import { render, staticRenderFns } from "./CancelamentoContrato.vue?vue&type=template&id=a11cd590"
import script from "./CancelamentoContrato.vue?vue&type=script&lang=js"
export * from "./CancelamentoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports